export default __webpack_public_path__ + "static/media/likesBackground.a5cc5eb9.svg";